import { createApp } from 'vue';
import { register } from '../../utils/index.mjs';
import '../../constants/index.mjs';
import UiLoading from '../../constants/components/loading/src/loading.vue.mjs';

const directive = {
  name: "loading",
  mounted: (el, res) => {
    const app = createApp(UiLoading, { message: "", visible: false });
    const instance = app.mount(document.createElement("div"));
    if (el.style.position == "") {
      el.classList.add("ui-relative");
    }
    el.app = app;
    el.instance = instance;
    el.appendChild(instance.$el);
    el.instance.$.props.visible = res.value;
  },
  updated: (el, res) => {
    if (el.instance) {
      el.instance.$.props.visible = res.value;
    }
  },
  unmounted: (el) => {
    el.app && el.app.unmount();
  }
};
const vLoading = register.use(directive, "directive");

export { vLoading as default, vLoading };
//# sourceMappingURL=index.mjs.map
